__webpack_require__.hmrF = () => ("applyisland." + __webpack_require__.h() + ".hot-update.json");